"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CO_PHONE_HELPER_CONFIG = void 0;
exports.CO_PHONE_HELPER_CONFIG = {
    validationRegex: /^([2-9*][\d*]{2})[\d*]{3}[\d*]{4}$/,
    countryCode: '57',
    phoneMask: '(###) ###-####',
    obfuscateMask: '(***) ***-####',
};
//# sourceMappingURL=COConfig.js.map